import React,{useState,useEffect} from 'react'
import templateService from '../../../services/template.service'
import { useNavigate } from 'react-router-dom';



const TemplateListItem = ({item,type})=>{
    const templatetype = type.toUpperCase()
    const navigate = useNavigate()
    function toProperCase(inputString) {
      // Split the string into words based on underscores
      let words = inputString.split('_');
  
      // Capitalize the first letter of each word and join them back
      let properCaseString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  
      return properCaseString;
  }
  const handleClick = (id)=>{
    console.log("Clicked"+id)
    if(templatetype === 'EMAIL')
        navigate(`/email-template/${id}`);
    if(templatetype === 'SMS')
        navigate(`/sms-template/${id}`);
    if(templatetype === 'CALL')
        navigate(`/telephone-template/${id}`);
  }
    return (
      <>
       <li className="list-group-item d-flex justify-content-between align-items-center">
                <div className="">
                    <div className="h5">{toProperCase(item.type)}</div>
                   <span className=""><small>Used by : {toProperCase(item.usedBy)}</small></span>
                </div>
                <div>
                   <button className="btn btn-sm btn-success" onClick={()=>handleClick(item.id)}><i className="bi bi-pencil-square"></i> Edit</button>
                  
                </div>
                
              </li>
      </>
    )
  }

  export default TemplateListItem